import { FormattedMessage } from 'react-intl';

import { useShortLocale } from '#configuration/lang/useLocale.ts';

import { ChecklistItem } from './ChecklistItem.tsx';

export type ChecklistProps = {
    userHasBooked: boolean;
};

export const Checklist = ({ userHasBooked }: ChecklistProps) => {
    const locale = useShortLocale();
    return (
        <div className='min-width-500-md max-width-100pct padding-top-25 margin-top-5 display-flex flex-column gap-25'>
            <div className='panel panel-default padding-x-20 padding-top-10 padding-bottom-20 rounded shadow-default'>
                <h4 className='margin-bottom-15'>
                    <FormattedMessage id='intl-msg:ordercom-cloud-frontend.welcome.header' />
                </h4>
                <div className='display-flex flex-column gap-10'>
                    <ChecklistItem
                        title='intl-msg:ordercom-cloud-frontend.welcome.checklist.booking.title'
                        description={{ id: 'intl-msg:ordercom-cloud-frontend.welcome.checklist.booking.description' }}
                        icon={userHasBooked ? 'icon-ok' : 'icon-warning-sign'}
                        done={userHasBooked}
                    />
                    <ChecklistItem
                        title='intl-msg:ordercom-cloud-frontend.welcome.checklist.download.title'
                        description={{
                            id: 'intl-msg:ordercom-cloud-frontend.welcome.checklist.download.description',
                            anchorValues: {
                                ios: 'https://apps.apple.com/app/apple-store/id1626828336',
                                android: 'https://play.google.com/store/apps/details?id=com.rio.pocketdriver',
                            },
                        }}
                        icon={'icon-download'}
                    />

                    <ChecklistItem
                        title='intl-msg:ordercom-cloud-frontend.welcome.checklist.manual.title'
                        description={{
                            id: 'intl-msg:ordercom-cloud-frontend.welcome.checklist.manual.description',
                            anchorValues: {
                                link: `https://rio.cloud/${locale}/documents/order-communication/how-to/user-manual`,
                            },
                        }}
                        icon={'icon-driver'}
                    />
                </div>
            </div>
        </div>
    );
};
